import {register} from '../vendor/theme-scripts/theme-sections';
import {collapsible} from '../features/collapsible';

const sections = {};

const selectors = {
  collapsibleTrigger: '[data-collapsible-trigger]',
};

const classes = {
  isExpanded: 'is-expanded',
};

class FaqList {
  triggerClick(evt) {
    const trigger = evt.target.querySelector(selectors.collapsibleTrigger);
    trigger.dispatchEvent(new Event('click'));
  }
}

const FaqListSection = {
  onLoad() {
    sections[this.id] = new FaqList(this);
  },
  onBlockSelect(e) {
    if (!e.target.classList.contains(classes.isExpanded)) {
      sections[this.id].triggerClick(e);
    }
  },
  onBlockDeselect(e) {
    if (e.target.classList.contains(classes.isExpanded)) {
      sections[this.id].triggerClick(e);
    }
  },
};

register('faq', [FaqListSection, collapsible]);
